import React from 'react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getWorkflows, executeWorkflow } from 'slices/thunk'
import { sortByLastModification } from 'helpers/utils/sortByLastModification'
import WorkflowsList from './components/WorkflowsList'
import DeleteModal from 'Common/DeleteModal'
import { Plus } from 'lucide-react'

const WorkflowList: React.FC = () => {
  document.title = 'Workflows | EngageHub IQ'
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()

  const [workflowList, setWorkflowList] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [workflowId, setWorkflowId] = useState('')

  const workflows = useSelector((state: any) => state.Workflow.workflows)
  const loading = useSelector((state: any) => state.Workflow.loading)

  useEffect(() => {
    if (workflows?.length === 0) return
    setWorkflowList(workflows)
  }, [workflows])

  useEffect(() => {
    dispatch(getWorkflows({}))
  }, [])

  const handleRunWorkflow = (workflowId: string) => {
    dispatch(executeWorkflow({ workflowId: workflowId }))
    console.log(`Running workflow with ID: ${workflowId}`)
  }

  const handleCancelWorkflow = (workflowId: string) => {
    dispatch(executeWorkflow({ workflowId: workflowId, action: 'Cancel' }))
    console.log(`Cancelling workflow with ID: ${workflowId}`)
  }

  const handleDeleteWorkflow = (workflowId: string) => {
    setDeleteModal(true)
    setWorkflowId(workflowId)
  }

  const handleDelete = () => {
    dispatch(executeWorkflow({ workflowId: workflowId, action: 'Delete' }))
    setWorkflowList(workflowList.filter((workflow: any) => workflow?.id !== workflowId))
    setDeleteModal(false)
    console.log(`Deleting workflow with ID: ${workflowId}`)
  }

  const handleEditWorkflow = (workflowId: string) => {
    navigate(`/workflow/designer/${workflowId}`)
  }

  const handleCreateWorkflow = () => {
    navigate(`/workflow/designer`)
  }

  return (
    <div className="h-[calc(100vh-70px)] flex flex-col">
      <div className="flex-shrink-0 p-6 pb-[12px] border-b border-slate-200 dark:border-zink-500">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-15 font-bold dark:text-zink-50">Workflow Management</h1>
            <p className="text-slate-600 dark:text-zink-200">Manage your automated workflows</p>
          </div>
          <button
            onClick={handleCreateWorkflow}
            type="button"
            className="text-xs sm:text-sm text-white btn bg-blue-500 hover:bg-blue-600 hover:text-white px-3 py-2 w-full sm:w-auto"
          >
            <Plus className="inline-block size-4" /> <span className="align-middle">Add Workflow</span>
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-6">
        <WorkflowsList
          loading={loading}
          onRunWorkflow={handleRunWorkflow}
          onCancelWorkflow={handleCancelWorkflow}
          onDeleteWorkflow={handleDeleteWorkflow}
          onEditWorkflow={handleEditWorkflow}
          workflows={sortByLastModification(workflowList)}
        />
      </div>

      <DeleteModal
        title="Are you sure you want to proceed?"
        content='This action cannot be undone.'
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        onDelete={handleDelete}
        cancelText='Cancel'
        deleteText='Delete'
      />
    </div>
  )
}

export default WorkflowList